import { Layer } from 'leaflet'
import { useLayerRegistry } from '@/js/editor/components/map/LayerRegistryContext.tsx'

type PoiId = string | number

export const useLayers = () => {
    const { getLayer } = useLayerRegistry()

    const findLayerByGeometryIndex = (poiId: PoiId, geometryIndex: number): Layer | undefined => {
        return getLayer(poiId, geometryIndex) ?? undefined
    }

    const findLayersByPoi = (poiId: PoiId, geometryCount: number): Layer[] => {
        return Array.from({ length: geometryCount }, (_, geometryIndex) => {
            return findLayerByGeometryIndex(poiId, geometryIndex)
        }).filter((layer): layer is Layer => layer !== undefined)
    }

    return {
        findLayerByGeometryIndex,
        findLayersByPoi,
    }
}
